import React from "react";
import "./ProfileMembers.css";
import DilipHero from "../../../Images/DilipHeroImage.jpg";
import DilipText from "../../../Images/DilipVengsarkarIndia.jpeg";

function ProfileMembers() {
  return (
    <>
      <div className="m-profiles-hero">
        <img src={DilipHero} alt="" />
      </div>

      <div className="sunilBabu">
        <div className="SunilbabuImage">
          <img src={DilipText} alt="" />
        </div>
        <div className="aboutSunilBabu">
          <div className="sunilBabuText">
            <p>
              Dilip Balwant Vengsarkar is a former Indian cricketer who played
              for India between 1975 and 1992. He was born on April 6, 1956, in
              Bombay (now Mumbai), India. Vengsarkar was a right-handed batsman
              and a part-time medium-pace bowler. He was known for his
              technically sound and stylish batting, and was considered one of
              the best batsmen of his generation. He played 116 Test matches for
              India and scored 6,868 runs at an average of 42.13, including 17
              centuries and 35 half-centuries. He also played in 129 One Day
              Internationals and scored 3,508 runs at an average of 34.73.
              Vengsarkar's most significant achievement came in 1986 when he
              became the first Indian cricketer to score three consecutive Test
              centuries against England. He was also part of the Indian team
              that won the World Cup in 1983 and played a crucial role in the
              tournament. After retiring from cricket, Vengsarkar served as the
              chairman of the national selection committee and also held several
              administrative positions in the Mumba i Cricket Association. He
              was inducted into the ICC Cricket Hall of Fame in 2021 in
              recognition of his outstanding contributions to the game. He is
              widely regarded as one of the greatest batsmen to have played for
              India. We are fortunate to have Indian cricketing legend, former
              captain and chief selector, Padma Shri Dilip Vengsarkar as mentor
              for ISBC,TSPL since 2016
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProfileMembers;
